import React from 'react'

const Footer = () => {
  return (
    <div className='absolute-center'>
      made with 🔥 by arvind
    </div>
  )
}

export default Footer
